import React from "react"
import styles from "./form-submit-button.module.scss"
import MaterialIcon from "../../material-icon/material-icon-view"

interface FormSubmitButtonProps {  
  submitState: SubmitState
  contents?: string
  submittingContents?: string
  submittedContents?: string
  disabled?: boolean
}

export enum SubmitState {
  Initial,
  Submitting,
  Submitted
}

export const FormSubmitButton: React.FC<FormSubmitButtonProps> = ({submitState, contents, submittingContents, submittedContents, disabled = false}) => {
  contents = contents || "Opslaan"
  submittingContents = submittingContents || "Bezig met opslaan"
  submittedContents = submittedContents || contents
  let buttonContents
  let buttonClass = ""
  switch (submitState) {
    case (SubmitState.Initial): {
      buttonContents = <span>{contents}</span>
      buttonClass= styles.Initial
      break
    }
    case (SubmitState.Submitting): {
      buttonContents = <>
        <MaterialIcon name="autorenew" className={styles.Rotating}/>
        <span>{submittingContents}</span>
      </>
      buttonClass = styles.Submitting
      disabled = true
      break
    }
    case (SubmitState.Submitted): {
      buttonContents = <>
        <MaterialIcon name="check"/>
        <span>{submittedContents}</span>
      </>
      buttonClass = styles.Submitted
      disabled = true
      break
    }
  }

  return <button type="submit" disabled={disabled} className={buttonClass}>
    <div className={styles.ButtonContent}>
      {buttonContents}
    </div>
  </button>
}
